import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { normalizeAnnouncementsSearchPage } from "@/features/announce/lib/announcementPagination";

export interface AnnouncementsSearch {
  page?: number;
}

export const Route = createFileRoute("/announcements/")({
  component: lazyRouteComponent(
    () => import("@/pages/AnnouncementsPage"),
    "AnnouncementsPage",
  ),
  validateSearch: (search: Record<string, unknown>): AnnouncementsSearch => ({
    page: normalizeAnnouncementsSearchPage(search.page),
  }),
});
